module.exports = __webpack_public_path__ + "static/media/pencil.6e3d5c1e.svg";